<template>
  <portlet
      :icon="'fad fa-file-contract'"
      :title="'Vacatures'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <router-link v-if="Can(rights.VACANCY_ADD)" tag="button" :to="{name:'vacancy-create'}" class="btn btn-secondary btn-add-vacancy">
        <i class="fas fa-plus-circle mr-2"></i> Toevoegen
      </router-link>
      <a @click="resetFilter(['vacancies-filter-state','vacancies-zip-filter-state'])">
        <button class="btn btn-primary mr-4">
          <i class=" fas fa-sync"></i> reset filter
        </button>
      </a>
    </template>

    <template v-if="Can(rights.VACANCY_VIEW)" slot="portletBody">
      <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
        <template v-if="!filterOpen">
          Filter vacatures
        </template>
        <template v-else>
          Sluit filter
        </template>
      </button>
      <div class="row dataTable-filters mb-5" :class="filterOpenClass">
        <div class="col-md-6 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ervaring ({{ customFilters[0].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(experience, index) in getVacancyExperiences"
                   :key="experience+'-'+index">
                <input v-model="customFilters[0].options.values"
                       :value="experience"
                       type="checkbox"
                       :id="experience+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="experience+'-'+index">
                  <span>{{ experience }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ploegen ({{ customFilters[1].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(shift, index) in getStandardFormChoices('shifts')"
                   :key="shift+'-'+index">
                <input v-model="customFilters[1].options.values"
                       :value="shift"
                       type="checkbox"
                       :id="'shift-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'shift-'+index">{{ shift }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-6 col-xl-2">
          <input id="getGeoLocation"
                 type="text"
                 class="form-control"
                 :class="{'is-invalid': checkZipCode}"
                 v-model="zipcode"
                 placeholder="1234 AB"
          >
          <span v-if="checkZipCode" class="small text-danger">Postcode is onjuist</span>
        </div>
        <div class="col-6 col-md-6 col-xl-2 rm-p-l zipcode-range-select">
          <select class="form-control" v-model.number="customFilters[2].options.range.max">
            <option value="999999999">Alle afstanden</option>
            <option value="5">< 5 km</option>
            <option value="10">< 10 km</option>
            <option value="15">< 15 km</option>
            <option value="20">< 20 km</option>
            <option value="25">< 25 km</option>
            <option value="30">< 30 km</option>
            <option value="35">< 35 km</option>
            <option value="40">< 40 km</option>
            <option value="45">< 45 km</option>
            <option value="50">< 50 km</option>
            <option value="75">< 75 km</option>
          </select>
        </div>
        <div class="col-md-4 col-xl-2 salary-range-filter">
          <label for="salaryRange" class="mb-1">Salaris Min/Max</label>
          <vue-slider
              v-model="salaryMinMax"
              id="salaryRange"
              :min="0"
              :max="100"
              :tooltip="'always'"
              :tooltip-placement="'bottom'"
              :silent="true"
              @change="setValueSalary"
          >
          </vue-slider>
        </div>
      </div>
      <datatables
          :tableClass="tableClass"
          v-if="getVacancies.length && renderedComponent"
          :rows="getVacancies"
          :columns="getColumns()"
          tableID="vacancies"
          :tableInitOptions="tableInitOptions"
          :customFilters="customFilters"
          routerLinkClass="dt-router-link"
          :deleteFunction="deleteVacancy"
          deleteClass="delete"
          @rowSelected="searchCandidate"
      ></datatables>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {getGeoLocation} from '../../components/mixins/getGeoLocation';
import {dataTables} from '../../components/mixins/dataTables';
import {swalModals} from '../../components/mixins/swalModals.js';
import { Can } from '../../../permission/ability.js';
import { RIGHTS } from '../roles/rights';

export default {
  mixins: [getGeoLocation, dataTables, swalModals],
  data() {
    return {
      rights: '',
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      zipcode: null,
      checkZipCode: false,
      salaryMinMax: [0, 100],
      filteredOptionsVacancy: [],
      tableInitOptions: {
        language: {
          sZeroRecords: 'Geen vacatures gevonden'
        }
      },
      customFilters: [
        {
          filter: 'arrayContainsExact',
          keyToFilter: 'experiences',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContainsExact',
          keyToFilter: 'shifts',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'getDistanceFromGeoCoord',
          keyToFilter: 'geoLocation',
          options: {
            range: {max: 999999999, min: 0},
            coordsFrom: null
          }
        },
        {
          filter: 'rangeFilter',
          keyToFilter: 'salaryFrom',
          options: {
            range: {
              min: 0,
              max: 100
            }
          }
        }
      ]
    };
  },
  methods: {
    Can,
    getColumns() {
      let self = this;
      return [
        {
          data: null, name: 'Vacature', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return '<a data-to="/vacancies/' + data.id + '" class="dt-router-link">' + data.name + '</a>';
          }
        },
        {
          data: null, name: 'Bedrijf', visible: true, searchable: true,
          render(data) {
            return '<a data-to="/customers/' + data.customerId + '" class="dt-router-link">' + self.getName(data.customerId) + '</a>';
          }
        },
        {
          data: null, name: 'Plaats', visible: true, searchable: true,
          render(data) {
            return self.getLocation(data.customerId);
          }
        },
        {
          data: null, name: 'Salaris', visible: true, searchable: true,
          render(data) {
            return '€ ' + (data.salaryFrom ? data.salaryFrom : '') + ' - ' + (data.salaryTo ? data.salaryTo : '');
          }
        },
        {data: 'experiences[, ]', name: 'Ervaring', visible: true, searchable: true},
        {data: 'driverLicense[, ]', name: 'Rijbewijs', visible: true, searchable: true},
        {
          data: null,
          name: 'Actief op website',
          visible: true,
          searchable: false,
          render(data) {
            return data.apiActive ? '<div class="active-on-website-checkmark"><i class="far fa-check"></i></div>' : ''
          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 2,
          render(data) {
            var options = '';
            if(Can(RIGHTS.VACANCY_EDIT)) {
                options += '<a data-to="/vacancies/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>';
            }

            if(Can(RIGHTS.VACANCY_DELETE)) {
                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
            }

            if(Can(RIGHTS.VACANCY_EDIT)) {
                options += '<i title="Kandidaat zoeken" class="far fa-search action-icon get-data"></i>';
            }
            return options;

          }
        },
        {data: 'geoLocation.lat', name: 'geoLat', visible: false, searchable: false},
        {data: 'geoLocation.lng', name: 'geoLng', visible: false, searchable: false}
      ];
    },

    getLocation(id) {
      let customer = _.find(this.getCustomers, {id: id});
      return customer ? customer.location : {};
    },
    getName(id) {
      let customer = _.find(this.getCustomers, {id: id});
      return customer ? customer.name : null;
    },

    setValueSalary(value) {
      this.customFilters[3].options.range.min = value[0];
      this.customFilters[3].options.range.max = value[1];
      localStorage.setItem('vacancies-filter-state', JSON.stringify(this.customFilters));

      return value;
    },

    deleteVacancy(vacancy) {
      let id = vacancy.id;
      this.swalDelete(vacancy.name).then(result => {
        if (result.value) {
          this.$store.dispatch('vacancies/delete', id);

          this.renderComponent();

          this.$toasted.global.successRequest({
            message: 'Vacature verwijderd'
          });
        }
      });
    },

    searchCandidate(value) {
      let vacancyObj = value;
      vacancyObj.salaryFrom = 1;
      vacancyObj.geoLocation = this.getCustomer(vacancyObj.customerId).geoLocation;
      vacancyObj.zipcode = this.getCustomer(vacancyObj.customerId).zipcode;
      this.$router.push({name: 'candidates', params: {vacancyObj}});
    },
    resetComponentFilter() {

    }
  },
  computed: {
    ...mapGetters('vacancies', ['getVacancies', 'getVacancyExperiences']),
    ...mapGetters('customers', ['getCustomers', 'getCustomer']),
    ...mapGetters('candidates', ['getStandardFormChoices'])
  },
  watch: {
    'filterOpen': function (val) {
      if (val) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    },
    'zipcode': function (val) {
      localStorage.setItem('vacancies-zip-filter-state', JSON.stringify(val));

      var regex = new RegExp('^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$');
      let trimmedZip = val.replace(/\s/g, '');
      if (trimmedZip.length === 6 && regex.test(trimmedZip)) {
        this.getGeoLocationfromPostal(trimmedZip).then((res) => {
          let geoData = res.data.results[0];
          if (geoData) {
            this.customFilters[2].options.coordsFrom = geoData.geometry.location;
            this.filteredOptionsVacancy.push(this.zipcode);
            this.checkZipCode = false;
          } else {
            this.checkZipCode = true;
          }
        });
      } else if (trimmedZip.length > 6) {
        this.checkZipCode = true;
      }
    },
    customFilters: {
      handler: function (val) {
        let customFilters = val.slice(0, 4)

        localStorage.setItem('vacancies-filter-state', JSON.stringify(customFilters));
        this.filteredOptionsVacancy = val;
      },
      deep: true
    }
  },
  created() {
    this.rights = RIGHTS;
    let candidateObj = this.$route.params.candidateObj;
    if (candidateObj) {
      this.customFilters[0].options.values = candidateObj.experiences.filter(i => this.getVacancyExperiences.indexOf(i) !== -1);
      this.customFilters[1].options.values = candidateObj.shifts;
      this.zipcode = candidateObj.zipcode;
      this.customFilters[2].options.range.max = candidateObj.travelDistance;
      this.customFilters[3].options.range.min = candidateObj.salaryMin;
      this.customFilters[3].options.range.max = 100;
      this.salaryMinMax = [candidateObj.salaryMin, 100];
    } else {
      let customFilterState = localStorage.getItem('vacancies-filter-state');
      let zipcodeFilter = localStorage.getItem('vacancies-zip-filter-state');
      if (zipcodeFilter) {
        this.zipcode = JSON.parse(zipcodeFilter)
      }
      if (customFilterState) {


        this.customFilters = JSON.parse(customFilterState);
        let salary = this.customFilters[3].options.range;
        this.salaryMinMax = [salary.max, salary.min];
      }
    }
  }
};
</script>
<style lang="scss" >
  .active-on-website-checkmark {
    color: #25b7bc;
    text-align: center;
  }
</style>